import {CSSProperties, FC} from 'react';


export interface IIconListNissanProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconListNissan: FC<IIconListNissanProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M5.91 17.005a1.112 1.112 0 0 0-.37-.245 1.073 1.073 0 0 0-.848 0 1.112 1.112 0 0 0-.369.245 1.175 1.175 0 0 0-.234.385c-.175.434-.083.936.234 1.272.109.103.234.186.369.245.27.125.578.125.849 0 .135-.06.26-.142.368-.245.317-.336.41-.837.235-1.272a1.175 1.175 0 0 0-.235-.385ZM8 7.333h11.2c.442 0 .8-.522.8-1.166C20 5.522 19.642 5 19.2 5H8c-.442 0-.8.522-.8 1.167 0 .644.358 1.166.8 1.166Zm-2.094 3.839c-.32-.331-.8-.428-1.215-.245-.135.059-.26.142-.368.245-.101.11-.18.242-.234.385-.12.282-.12.604 0 .886.057.142.136.272.234.385.109.103.233.186.368.245.27.125.578.125.847 0 .135-.059.26-.142.368-.245.099-.113.178-.243.234-.385.12-.282.12-.604 0-.886a1.174 1.174 0 0 0-.234-.385Zm13.294-.339H8c-.442 0-.8.523-.8 1.167s.358 1.167.8 1.167h11.2c.442 0 .8-.523.8-1.167s-.358-1.167-.8-1.167ZM5.906 5.338a1.11 1.11 0 0 0-.368-.245 1.078 1.078 0 0 0-1.215.245 1.351 1.351 0 0 0-.234.385c-.12.283-.12.605 0 .887.057.141.136.272.234.385.109.103.233.186.368.245.415.183.895.086 1.215-.245.099-.113.178-.244.234-.385.12-.282.12-.604 0-.887a1.351 1.351 0 0 0-.234-.385ZM19.2 16.667H8c-.442 0-.8.522-.8 1.166 0 .645.358 1.167.8 1.167h11.2c.442 0 .8-.522.8-1.167 0-.644-.358-1.166-.8-1.166Z" clipRule="evenodd" />
        </svg>
    );
};
